import React from 'react';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';
import { Equipment } from '~/data-classes';
import { TableHeaderRowProps } from '../types';
import './EquipmentTableHeaderRow.scss';

const ROOT_CLASS_NAME = 'equipment-table__table-header-cell';

export const EquipmentTableHeaderRow = ({
    headerGroup,
    hasSelectedRows
}: TableHeaderRowProps<Equipment>) => {
    const elementClassName = classNames(ROOT_CLASS_NAME, {
        [`${ROOT_CLASS_NAME}--has-selected`]: hasSelectedRows
    });

    return (
        <tr role="row">
            <th role="columnheader" className={elementClassName}>
                &nbsp;
            </th>
            {headerGroup.headers.map((header) => (
                <th
                    key={header.id}
                    role="columnheader"
                    className={elementClassName}
                    data-testid={header.id}
                >
                    {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                    )}
                </th>
            ))}
        </tr>
    );
};
